import React from 'react'
import './CoreValues.css'

const PILLARS = [
  {
    id: 'vision',
    label: 'Vision',
    color: '#FFB7CE',
    colorSoft: 'rgba(255,183,206,0.08)',
    colorBorder: 'rgba(255,183,206,0.25)',
    text: 'To become a leading African technology company recognized for creating impactful digital products and custom solutions that drive innovation and long-term transformation.',
  },
  {
    id: 'mission',
    label: 'Mission',
    color: '#c084fc',
    colorSoft: 'rgba(192,132,252,0.08)',
    colorBorder: 'rgba(192,132,252,0.25)',
    text: 'To build innovative, scalable, and user-centered digital solutions that help businesses and individuals operate more efficiently, grow confidently, and achieve their goals through technology.',
  },
  {
    id: 'purpose',
    label: 'Purpose',
    color: '#67e8a9',
    colorSoft: 'rgba(103,232,169,0.08)',
    colorBorder: 'rgba(103,232,169,0.25)',
    text: 'To empower individuals, organizations and communities by turning ideas into practical digital systems that solve real-world problems and create lasting value.',
  },
]

const VALUES = [
  {
    icon: '',
    title: 'Innovation',
    desc: 'We embrace creativity and emerging technologies to solve complex problems; not because it\'s trendy, but because our clients deserve forward-thinking solutions.',
  },
  {
    icon: '',
    title: 'Excellence',
    desc: 'We deliver quality that stands the test of time. Every line of code, every design decision, every interaction is held to the highest standard.',
  },
  {
    icon: '',
    title: 'Integrity',
    desc: 'We build honest relationships through transparency and accountability. We say what we mean, and we do what we say.',
  },
  {
    icon: '',
    title: 'Collaboration',
    desc: 'Great products are built through partnership. We work alongside our clients; not just for them; to ensure every solution truly fits.',
  },
  {
    icon: '',
    title: 'Continuous Learning',
    desc: 'Technology evolves; and so do we. We stay ahead of the curve so our clients always benefit from the best that the industry has to offer.',
  },
]

export default function CoreValues() {
  return (
    <section className='cv-section' id='values'>

      {/* ── VMP Chain ── */}
      <div className='cv-vmp-wrap'>
        <div className='cv-vmp-label'>
          <span className='cv-eyebrow'>What drives us</span>
        </div>
        <div className='cv-chain'>
          {PILLARS.map((p, i) => (
            <React.Fragment key={p.id}>
              <div
                className='cv-ring'
                style={{
                  '--ring-color':  p.color,
                  '--ring-soft':   p.colorSoft,
                  '--ring-border': p.colorBorder,
                }}
              >
                <div className='cv-ring-inner'>
                  <span className='cv-ring-title'>{p.label}</span>
                  <p className='cv-ring-text'>{p.text}</p>
                </div>
              </div>
              {i < PILLARS.length - 1 && (
                <div className='cv-connector'>
                  <svg viewBox='0 0 24 40' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
                    <path d='M12 0 L12 18 L20 28 L12 38 L4 28 L12 18' stroke='rgba(255,255,255,0.12)' strokeWidth='1.5' fill='none' strokeLinecap='round' strokeLinejoin='round'/>
                    <circle cx='12' cy='28' r='3' fill='rgba(255,255,255,0.08)' stroke='rgba(255,255,255,0.18)' strokeWidth='1'/>
                  </svg>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* ── Core Values ── */}
      <div className='cv-values-wrap'>
        <div className='cv-values-header'>
          <span className='cv-eyebrow'>Our core values</span>
          <h2 className='cv-values-title'>
            The principles that guide<br />
            <em>everything we build</em>
          </h2>
        </div>
        <div className='cv-values-grid'>
          {VALUES.map((v) => (
            <div className='cv-value-card' key={v.title}>
              <span className='cv-value-icon' aria-hidden='true'>{v.icon}</span>
              <h3 className='cv-value-title'>{v.title}</h3>
              <p className='cv-value-desc'>{v.desc}</p>
            </div>
          ))}
        </div>
      </div>

    </section>
  )
}